module.exports = __webpack_public_path__ + "media/src/assets/share_boat_2-25f9d74135cff2b7c5fe41a09918771a.png";